import type { EventingContext } from '../../types/context';
import type {
  NormalizedInteraction,
  NormalizedView,
} from '../../types/normalized';
import type { EventingAdapter, NormalizedConversion } from '../types';

type LinkedInTracker = (...args: unknown[]) => void;

export interface LinkedInAdapterOptions {
  readonly partnerId: string;
  readonly onError?: (error: unknown) => void;
}

export class LinkedInAdapter implements EventingAdapter {
  readonly name = 'linkedin';

  private readonly partnerId: string;
  private readonly onError?: (error: unknown) => void;

  constructor({ partnerId, onError }: LinkedInAdapterOptions) {
    this.partnerId = partnerId;
    this.onError = onError;
  }

  handleInteraction(
    _interaction: NormalizedInteraction,
    _context: EventingContext,
  ): void {
    return;
  }

  handleView(_view: NormalizedView, _context: EventingContext): void {
    return;
  }

  handleConversion(
    _conversion: NormalizedConversion,
    _context: EventingContext,
  ): void {
    try {
      (window as Window & { lintrk?: LinkedInTracker }).lintrk?.('track', {
        conversion_id: this.partnerId,
      });
    } catch (error) {
      this.onError?.(error);
    }
  }
}
